import * as Sentry from '@sentry/react';

import { env } from '@/config/env';

/**
 * Initialize Sentry error monitoring + performance tracing.
 *
 * No-op unless a DSN is configured and we are not in local development,
 * so dev runs and missing-config builds stay silent.
 */
export function initSentry(): void {
  if (!env.SENTRY_DSN || import.meta.env.MODE === 'development') {
    return;
  }

  Sentry.init({
    dsn: env.SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: env.APP_VERSION,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
  });
}
